// @flow
import { push, goBack } from "react-router-redux";

export default {
  push,
  goBack
};
